import { zetApi } from '@zet/network'

export async function shareVerificationLink(customerId: number | string) {
  const { data } = await zetApi.get(
    `/customer/generateShareLink/v2?linkType=otpVerify&customerId=${customerId}`
  )
  return data
}
